import documentMetadataService from "@/services/documentMetadataService.js";
import metadataType from "../constants/metadataType";
import moment from "moment";

export default {
  translateResultSet: (resultSet, dateFormat) => {
    const headers = resultSet.columns.map(column => {
      if (column.name.includes("Party")) column.name = column.name.replace("Party", "Connection");
      else if (column.name.includes("Parties")) column.name = column.name.replace("Parties", "Connections");

      return {
        title: column.name,
        key: column.key,
        metadataTypeId: column.metadataType.id,
        sort: (a, b) => {
          if (column.metadataType.id === metadataType.Date) {
            return moment(b, dateFormat).toDate() - moment(a, dateFormat).toDate();
          } else {
            if (a == null && b == null) return 0;
            if (a == null) return -1;
            if (b == null) return 1;
            return b.toString().localeCompare(a.toString());
          }
        },
      };
    });

    const rows = resultSet.rows.map(item => {
      let document = { id: item.id, routeStatusId: item.routeStatusId, isRead: item.isRead };
      headers.forEach((column, index) => {
        document[column.key] = documentMetadataService.format(column.metadataTypeId, item.values[index], dateFormat);
      });

      return document;
    });

    headers.push({ title: "Status", key: "routeStatusId", metadataTypeId: metadataType.Numeric });

    return {
      headers,
      rows,
    };
  },
};
